<template>
  <div class="wish-list-contents__share-contents">
    <div class="share-contents__header">
      <div class="share-contents__title body-bold">
        ほしいものリストをシェアする
      </div>
    </div>
    <div class="share-contents__body">
      <div class="share-contents">
        <ButtonSnsSmallX @click-x-button="onClickXButton" />
        <ButtonSnsSmallFacebook
          @click-facebook-button="onClickFacebookButton"
        />
        <ButtonSnsSmallLink @click-link-button="copyShareUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonSnsSmallX from '../../../molecules/buttons/sns/ButtonSnsSmallX.vue'
import ButtonSnsSmallFacebook from '../../../molecules/buttons/sns/ButtonSnsSmallFacebook.vue'
import ButtonSnsSmallLink from '../../../molecules/buttons/sns/ButtonSnsSmallLink.vue'

export default {
  components: {
    ButtonSnsSmallX,
    ButtonSnsSmallFacebook,
    ButtonSnsSmallLink
  },
  props: {
    host: {
      type: String,
      require: true,
      default: ''
    },
    screenName: {
      type: String,
      require: true,
      default: ''
    }
  },
  computed: {
    shareUrl() {
      return `https://${this.host}/u/${this.screenName}`
    }
  },
  methods: {
    onClickXButton() {
      window.open(
        `https://twitter.com/intent/tweet?text=gifteeで${this.screenName}のほしいものをチェック！&hashtags=giftee&url=${this.shareUrl}&original_referer=${this.shareUrl}`,
        '_blank'
      )
    },
    onClickFacebookButton() {
      window.open(
        `https://www.facebook.com/sharer.php?u=${this.shareUrl}`,
        '_blank'
      )
    },
    copyShareUrl() {
      navigator.clipboard.writeText(this.shareUrl)
      this.$emit('show-share-feedback', 'URLをコピーしました')
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-contents {
  &__share-contents {
    max-width: $small-contents-width;
    margin: 0 auto;
    padding: 24px 16px;
    border-top: 1px solid $gray-2;
    text-align: center;

    .share-contents {
      display: grid;
      grid-auto-flow: column;
      gap: 24px;
      justify-content: center;

      &__header {
        margin-bottom: 32px;
      }

      .btn-sns--copy {
        @include bg-settings('../images/buttons/copy-link.svg', $black);

        background-repeat: no-repeat, no-repeat;
        background-size: 24px 24px, contain;
      }

      button {
        width: 56px;
        height: 56px;
      }
    }
  }
}
</style>
